import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { logout } from '../../services/auth';
import ListingsManager from './ListingsManager';
import SiteSettings from './SiteSettings';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleLogout = () => {
    logout();
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f7fa' }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: '#1a1d29',
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        <Toolbar sx={{ py: 2, px: { xs: 2, sm: 3 } }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              fontWeight: 500,
              fontSize: '1.125rem',
              letterSpacing: '0.02em',
              color: '#ffffff',
            }}
          >
            Property Management System
          </Typography>
          <Button
            onClick={handleLogout}
            variant="text"
            sx={{
              color: '#ffffff',
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '0.875rem',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.08)',
              }
            }}
          >
            Sign Out
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl" sx={{ mt: 5, mb: 5, px: { xs: 2, sm: 3 } }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ mb: 4 }}
        >
          <Tab label="Listings" />
          <Tab label="Site Settings" />
        </Tabs>
        {activeTab === 0 && <ListingsManager />}
        {activeTab === 1 && <SiteSettings />}
      </Container>
    </Box>
  );
};

export default Dashboard;
